<div class="dialog modal-md">
    <div class="dialog-title">
        <h4>Pdf Viewer<img src="assets/svg/close-white.svg" alt="close" (click)="close()" ></h4>
    </div>
    <div class="content">
        <div class="paginationInline mb-0">

            <div class="btn-blocks button-area">
                <a data-title="Page up" (click)="previousPage()"><i
                    class="fa fa-arrow-circle-up two"></i></a>
                    <span class="pageCounter">
                        <span class="inputBox totalpage">{{pagevariable}}</span> / <span class="inputBox totalpage">{{outputtotalpages}}</span>
                    </span>
                <a data-title="Page down" (click)="nextPage()"><i
                    class="fa fa-arrow-circle-down three"></i></a>
                    
                    <span class="part"></span>
                    <a data-title="Zoom in" (click)="zoomin()"><i  class="fa fa-search-plus six"></i></a>
                    <a data-title="Zoom out" (click)="zoomout()"><i 
                    class="fa fa-search-minus seven"></i></a>
                <span class="part"></span>
                <span class="part"></span>
            </div>
          </div>
          <pinch-zoom #myPinch="pinchZoom"  [wheel]="true" backgroundColor="light grey">
            <pdf-viewer [src]="pdfSrc"
                [render-text]="true"
                [original-size]="false"
                [show-all]="false"
                [(page)]="pagevariable"
                (after-load-complete)="afterLoadComplete($event)"
            ></pdf-viewer>
          </pinch-zoom>
    </div>
</div>